// extracted by mini-css-extract-plugin
export default {"footer":"HelpPage_footer__54Jki"};